import React from 'react';
import BenchmarkWebApp from '@/pages/BenchmarkWebApp';

export const benchmarkRoutes = [
  {
    path: "/benchmark-webapp",
    element: <BenchmarkWebApp />,
  },
];
